import React, { useContext, useState } from 'react';
import { Popover, PopoverTrigger, ToggleButton } from '@fluentui/react-components';
import InfoIcon from '@mui/icons-material/Info';
import { reportMixPanel } from '@55degrees/consent-tracker';
import { CustomPopoverSurface } from '../styling';
import TableRenderer from './TableRenderer';
import { A3DocumentContext } from '../../../../contexts/A3DocumentContext';

function DataSetInformation() {
  const { datasetInfoProperties } = useContext(A3DocumentContext);
  const [isOpen, setIsOpen] = useState(false);

  if (datasetInfoProperties?.isHidden) return null;
  if (!datasetInfoProperties?.data?.length) return null;

  const onOpenChange = (e, { open }) => {
    setIsOpen(open);
    if (open) {
      reportMixPanel('Data Set Info View');
    }
  };
  const { data } = datasetInfoProperties;

  return (
    <Popover positioning="below-start" open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger>
        <ToggleButton checked={isOpen} icon={<InfoIcon fontSize="small" />} appearance="subtle" />
      </PopoverTrigger>
      <CustomPopoverSurface>
        <TableRenderer tableContent={data} />
      </CustomPopoverSurface>
    </Popover>
  );
}

export default DataSetInformation;
